(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.Tiempos', Tiempos);

    Tiempos.$inject = ['$scope', '$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Tiempos($scope, $animationsSrv, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();

        //const ESTADO_CONFIRMADO = 2;

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();
        var permisosTiempos = UserInfoService.getPermisosAgregarTiempos();

        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosInscripciones.guardar === true,
            puedeModificar: permisosInscripciones.modificar === true,
            puedeEliminar: permisosInscripciones.eliminar === true,
            puedeVerBusqueda: permisosTiempos.ver === true,
            diaNoSeleccionado() {return vm.criteriosBusqueda.dia === 0},
            ordenarPor(){
                if(vm.criteriosBusqueda.dia === 0)
                {
                    return 'numero';
                }

                const sortProperty = `horaLlegadaRegistrada${vm.criteriosBusqueda.dia == 1 ? '' : vm.criteriosBusqueda.dia}`
                return sortProperty;
            },
            diaEnRango(currentDay){
                const evento = vm.eventos.find((e)=>{return e.id == vm.criteriosBusqueda.eventoId;});
                if(evento)
                {
                    return evento.dias >= currentDay;
                }

                return false;
            },
            verDia1() { return  this.diaEnRango(1) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 1)},
            verDia2() { return  this.diaEnRango(2) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 2)},
            verDia3() { return  this.diaEnRango(3) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 3)},
            verDia4() { return  this.diaEnRango(4) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 4)},
            verDia5() { return  this.diaEnRango(5) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 5)},
            verDia6() { return  this.diaEnRango(6) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 6)},
            verDia7() { return  this.diaEnRango(7) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 7)},
            verDia8() { return  this.diaEnRango(8) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 8)},
            verDia9() { return  this.diaEnRango(9) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 9)},
            verDia10() { return  this.diaEnRango(10) && (this.diaNoSeleccionado() || vm.criteriosBusqueda.dia === 10)},
            verBotonGuardar(item){
                const diaSeleccionado = vm.criteriosBusqueda.dia;
                return diaSeleccionado === 1 && !item.horaLlegadaRegistrada ||
                diaSeleccionado === 2 && !item.horaLlegadaRegistrada2 ||
                diaSeleccionado === 3 && !item.horaLlegadaRegistrada3 ||
                diaSeleccionado === 4 && !item.horaLlegadaRegistrada4 ||
                diaSeleccionado === 5 && !item.horaLlegadaRegistrada5 ||
                diaSeleccionado === 6 && !item.horaLlegadaRegistrada6 ||
                diaSeleccionado === 7 && !item.horaLlegadaRegistrada7 ||
                diaSeleccionado === 8 && !item.horaLlegadaRegistrada8 ||
                diaSeleccionado === 9 && !item.horaLlegadaRegistrada9 ||
                diaSeleccionado === 10 && !item.horaLlegadaRegistrada10;
            },
            verBotonModificar(item){
                const diaSeleccionado = vm.criteriosBusqueda.dia;
                return diaSeleccionado === 1 && item.horaLlegadaRegistrada ||
                diaSeleccionado === 2 && item.horaLlegadaRegistrada2 ||
                diaSeleccionado === 3 && item.horaLlegadaRegistrada3 ||
                diaSeleccionado === 4 && item.horaLlegadaRegistrada4 ||
                diaSeleccionado === 5 && item.horaLlegadaRegistrada5 ||
                diaSeleccionado === 6 && item.horaLlegadaRegistrada6 ||
                diaSeleccionado === 7 && item.horaLlegadaRegistrada7 ||
                diaSeleccionado === 8 && item.horaLlegadaRegistrada8 ||
                diaSeleccionado === 9 && item.horaLlegadaRegistrada9 ||
                diaSeleccionado === 10 && item.horaLlegadaRegistrada10;
            },
            emailResultadoEnviado(item){
                const diaActual = vm.criteriosBusqueda.dia;

                let result = false;

                switch (diaActual) {
                    case 1:
                        result = item.emailResultadoEnviado;
                        break;
                    case 2:
                        result = item.emailResultadoEnviado2;
                        break;
                    case 3:
                        result = item.emailResultadoEnviado3;
                        break;
                    case 4:
                        result = item.emailResultadoEnviado4;
                        break;
                    case 5:
                        result = item.emailResultadoEnviado5;
                        break;
                    case 6:
                        result = item.emailResultadoEnviado6;
                        break;
                    case 7:
                        result = item.emailResultadoEnviado7;
                        break;
                    case 8:
                        result = item.emailResultadoEnviado8;
                        break;
                    case 9:
                        result = item.emailResultadoEnviado9;
                        break;
                    case 10:
                        result = item.emailResultadoEnviado10;
                        break;
                }

                return result;
            }
        };

        vm.criteriosBusqueda = {
            eventoId: 0,
            estado: 0,
            usuarioId: 0,
            inscriptorId: 0,
            categoriaId: 0,
            numero: '',
            dia: 0,
            nombre: '',
            apellidos: '',
            apellido2: ''
        };

        vm.displayLimits = [
            {
                id: 10,
                descripcion: '10 Registros'
            },
            {
                id: 20,
                descripcion: '20 Registros'
            },
            {
                id: 50,
                descripcion: '50 Registros'
            },
            {
                id: undefined,
                descripcion: 'Todos'
            },
        ];

        vm.displayLimit = vm.displayLimits[0].id;

        vm.collection = [];
        vm.collectionCopy = [];

        vm.eventos = [];
        vm.categorias = [];
        vm.dias = [];

        vm.title = 'Tiempos';

        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getRemoteController()
        {
            return 'api/Inscripciones/All-Hijos';
        };

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                eventoId: 0,
                estado: 0,
                usuarioId: 0,
                inscriptorId: 0,
                categoriaId: 0,
                numero: '',
                dia: 0,
                nombre: '',
                apellidos: '',
                apellido2: ''
            };
        };

        //getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, 'eventoId' );
        };

        function getAll(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                ApiBaseService.remoteController = getRemoteController();

                const criterios = [
                    vm.criteriosBusqueda.eventoId,
                    vm.criteriosBusqueda.estado,
                    vm.criteriosBusqueda.inscriptorId,
                    vm.criteriosBusqueda.categoriaId,
                    vm.criteriosBusqueda.nombre === '' ? '0' : vm.criteriosBusqueda.nombre,
                    vm.criteriosBusqueda.apellidos === '' ? '0' : vm.criteriosBusqueda.apellidos,
                    vm.criteriosBusqueda.apellido2 === '' ? '0' : vm.criteriosBusqueda.apellido2
                ];
    
                var promise = ApiBaseService.getAll(criterios);
    
                promise
                .then(function(collection){
                    collection.forEach((c)=>{
                        c.horaLlegada = c.horaLlegada == null || c.horaLlegada == undefined ? moment().toDate() : c.horaLlegada;
                        c.horaLlegada2 = c.horaLlegada2 == null || c.horaLlegada2 == undefined ? moment().toDate() : c.horaLlegada2;
                        c.horaLlegada3 = c.horaLlegada3 == null || c.horaLlegada3 == undefined ? moment().toDate() : c.horaLlegada3;
                        c.horaLlegada4 = c.horaLlegada4 == null || c.horaLlegada4 == undefined ? moment().toDate() : c.horaLlegada4;
                        c.horaLlegada5 = c.horaLlegada5 == null || c.horaLlegada5 == undefined ? moment().toDate() : c.horaLlegada5;
                        c.horaLlegada6 = c.horaLlegada6 == null || c.horaLlegada6 == undefined ? moment().toDate() : c.horaLlegada6;
                        c.horaLlegada7 = c.horaLlegada7 == null || c.horaLlegada7 == undefined ? moment().toDate() : c.horaLlegada7;
                        c.horaLlegada8 = c.horaLlegada8 == null || c.horaLlegada8 == undefined ? moment().toDate() : c.horaLlegada8;
                        c.horaLlegada9 = c.horaLlegada9 == null || c.horaLlegada9 == undefined ? moment().toDate() : c.horaLlegada9;
                        c.horaLlegada10 = c.horaLlegada10 == null || c.horaLlegada10 == undefined ? moment().toDate() : c.horaLlegada10;

                        c.segundos = typeof c.horaLlegada.getSeconds === 'function' ? c.horaLlegada.getSeconds() : new Date(c.horaLlegada).getSeconds();
                        c.segundos2 = typeof c.horaLlegada2.getSeconds === 'function' ? c.horaLlegada2.getSeconds() : new Date(c.horaLlegada2).getSeconds();
                        c.segundos3 = typeof c.horaLlegada3.getSeconds === 'function' ? c.horaLlegada3.getSeconds() : new Date(c.horaLlegada3).getSeconds();
                        c.segundos4 = typeof c.horaLlegada4.getSeconds === 'function' ? c.horaLlegada4.getSeconds() : new Date(c.horaLlegada4).getSeconds();
                        c.segundos5 = typeof c.horaLlegada5.getSeconds === 'function' ? c.horaLlegada5.getSeconds() : new Date(c.horaLlegada5).getSeconds();
                        c.segundos6 = typeof c.horaLlegada6.getSeconds === 'function' ? c.horaLlegada6.getSeconds() : new Date(c.horaLlegada6).getSeconds();
                        c.segundos7 = typeof c.horaLlegada7.getSeconds === 'function' ? c.horaLlegada7.getSeconds() : new Date(c.horaLlegada7).getSeconds();
                        c.segundos8 = typeof c.horaLlegada8.getSeconds === 'function' ? c.horaLlegada8.getSeconds() : new Date(c.horaLlegada8).getSeconds();
                        c.segundos9 = typeof c.horaLlegada9.getSeconds === 'function' ? c.horaLlegada9.getSeconds() : new Date(c.horaLlegada9).getSeconds();
                        c.segundos10 = typeof c.horaLlegada10.getSeconds === 'function' ? c.horaLlegada10.getSeconds() : new Date(c.horaLlegada10).getSeconds();
                    });
                    vm.collection = collection;
                    vm.collectionCopy = [...vm.collection];
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los datos.');
                            break;
                    }
                });
            }
        };

        vm.save = function(item)
        {
            item.diaActual = vm.criteriosBusqueda.dia;

            item.horaLlegada = typeof item.horaLlegada === 'string' ? new Date(item.horaLlegada) : item.horaLlegada;
            item.horaLlegada2 = typeof item.horaLlegada2 === 'string' ? new Date(item.horaLlegada2) : item.horaLlegada2;
            item.horaLlegada3 = typeof item.horaLlegada3 === 'string' ? new Date(item.horaLlegada3) : item.horaLlegada3;
            item.horaLlegada4 = typeof item.horaLlegada4 === 'string' ? new Date(item.horaLlegada4) : item.horaLlegada4;
            item.horaLlegada5 = typeof item.horaLlegada5 === 'string' ? new Date(item.horaLlegada5) : item.horaLlegada5;
            item.horaLlegada6 = typeof item.horaLlegada6 === 'string' ? new Date(item.horaLlegada6) : item.horaLlegada6;
            item.horaLlegada7 = typeof item.horaLlegada7 === 'string' ? new Date(item.horaLlegada7) : item.horaLlegada7;
            item.horaLlegada8 = typeof item.horaLlegada8 === 'string' ? new Date(item.horaLlegada8) : item.horaLlegada8;
            item.horaLlegada9 = typeof item.horaLlegada9 === 'string' ? new Date(item.horaLlegada9) : item.horaLlegada9;
            item.horaLlegada10 = typeof item.horaLlegada10 === 'string' ? new Date(item.horaLlegada10) : item.horaLlegada10;

            vm.update(item);
        };

        vm.update = function(data){
            ApiBaseService.remoteController = 'api/Inscripciones/AgregarTiempo';
            var promise = ApiBaseService.update(data);
            
            promise
            .then(function(response){
                postUpdateHoraLlegada(data, response);
                logger.success('Registro modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        function postUpdateHoraLlegada(data, response)
        {
            switch (vm.criteriosBusqueda.dia) {
                case 1:
                    updateValues(data, "horaLlegada", "horaLlegadaRegistrada", 
                    response.data.object.horaLlegada, response.data.object.horaLlegadaRegistrada);
                    break;
                case 2:
                    updateValues(data, "horaLlegada2", "horaLlegadaRegistrada2", 
                    response.data.object.horaLlegada2, response.data.object.horaLlegadaRegistrada2);
                    break;
                case 3:
                    updateValues(data, "horaLlegada3", "horaLlegadaRegistrada3", 
                    response.data.object.horaLlegada3, response.data.object.horaLlegadaRegistrada3);
                    break;
                case 4:
                    updateValues(data, "horaLlegada4", "horaLlegadaRegistrada4", 
                    response.data.object.horaLlegada4, response.data.object.horaLlegadaRegistrada4);
                    break;
                case 5:
                    updateValues(data, "horaLlegada5", "horaLlegadaRegistrada5", 
                    response.data.object.horaLlegada5, response.data.object.horaLlegadaRegistrada5);
                    break;
                case 6:
                    updateValues(data, "horaLlegada6", "horaLlegadaRegistrada6", 
                    response.data.object.horaLlegada6, response.data.object.horaLlegadaRegistrada6);
                    break;
                case 7:
                    updateValues(data, "horaLlegada7", "horaLlegadaRegistrada7", 
                    response.data.object.horaLlegada7, response.data.object.horaLlegadaRegistrada7);
                    break;
                case 8:
                    updateValues(data, "horaLlegada8", "horaLlegadaRegistrada8", 
                    response.data.object.horaLlegada8, response.data.object.horaLlegadaRegistrada8);
                    break;
                case 9:
                    updateValues(data, "horaLlegada9", "horaLlegadaRegistrada9", 
                    response.data.object.horaLlegada9, response.data.object.horaLlegadaRegistrada9);
                    break;
                case 10:
                    updateValues(data, "horaLlegada10", "horaLlegadaRegistrada10", 
                    response.data.object.horaLlegada10, response.data.object.horaLlegadaRegistrada10);
                    break;
                default:
                    break;
            }
        };

        function updateValues(data, propHoraLlegada, propHoraLLegadaReg, horaLlegadaValue, horaLlegadaRegValue)
        {
            vm.collectionCopy.forEach(function(element) {
                if(element.id === data.id)
                {
                    element[propHoraLlegada] = horaLlegadaValue; 
                    element[propHoraLLegadaReg] = horaLlegadaRegValue;                      
                }
            });
            data[propHoraLLegadaReg] = horaLlegadaRegValue;
        };

        vm.sendEmail = function(data){
            data.diaActual = vm.criteriosBusqueda.dia;
            ApiBaseService.remoteController = 'api/Inscripciones/EnviarResultadoEmail';
            var promise = ApiBaseService.update(data);
            
            promise
            .then(function(response){

                vm.collectionCopy.forEach(function(element) {
                    if(element.id === data.id)
                    {
                        vm.setEmailEnviado(element);
                    }
                });
                vm.setEmailEnviado(data);

                logger.success('Email enviado!.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.setEmailEnviado = function(item)
        {
            const diaActual = vm.criteriosBusqueda.dia;

            switch (diaActual) {
                case 1:
                    item.emailResultadoEnviado = true;
                    break;
                case 2:
                    item.emailResultadoEnviado2 = true;
                    break;
                case 3:
                    item.emailResultadoEnviado3 = true;
                    break;
                case 4:
                    item.emailResultadoEnviado4 = true;
                    break;
                case 5:
                    item.emailResultadoEnviado5 = true;
                    break;
                case 6:
                    item.emailResultadoEnviado6 = true;
                    break;
                case 7:
                    item.emailResultadoEnviado7 = true;
                    break;
                case 8:
                    item.emailResultadoEnviado8 = true;
                    break;
                case 9:
                    item.emailResultadoEnviado9 = true;
                    break;
                case 10:
                    item.emailResultadoEnviado10 = true;
                    break;
            }

        };

        vm.onTextChanged = function(property){
            switch (property) {
                case "numero":
                    onNumeroChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onNumeroChanged(property)
        {

            vm.collection = [...vm.collectionCopy];

            if(vm.criteriosBusqueda.numero && vm.criteriosBusqueda.numero.toString().trim() != '')
            {
                vm.collection = vm.collection.filter(function(c) {
                    return c.numero == vm.criteriosBusqueda.numero;
                });  
                
                vm.collection.forEach((c)=>{
                    c.horaLlegada = c.horaLlegadaRegistrada == false ? moment().toDate() : c.horaLlegada;
                    c.horaLlegada2 = c.horaLlegadaRegistrada2 == false ? moment().toDate() : c.horaLlegada2;
                    c.horaLlegada3 = c.horaLlegadaRegistrada3 == false ? moment().toDate() : c.horaLlegada3;
                    c.horaLlegada4 = c.horaLlegadaRegistrada4 == false ? moment().toDate() : c.horaLlegada4;
                    c.horaLlegada5 = c.horaLlegadaRegistrada5 == false ? moment().toDate() : c.horaLlegada5;
                    c.horaLlegada6 = c.horaLlegadaRegistrada6 == false ? moment().toDate() : c.horaLlegada6;
                    c.horaLlegada7 = c.horaLlegadaRegistrada7 == false ? moment().toDate() : c.horaLlegada7;
                    c.horaLlegada8 = c.horaLlegadaRegistrada8 == false ? moment().toDate() : c.horaLlegada8;
                    c.horaLlegada9 = c.horaLlegadaRegistrada9 == false ? moment().toDate() : c.horaLlegada9;
                    c.horaLlegada10 = c.horaLlegadaRegistrada10 == false ? moment().toDate() : c.horaLlegada10;

                    c.segundos = typeof c.horaLlegada.getSeconds === 'function' ? c.horaLlegada.getSeconds() : new Date(c.horaLlegada).getSeconds();
                    c.segundos2 = typeof c.horaLlegada2.getSeconds === 'function' ? c.horaLlegada2.getSeconds() : new Date(c.horaLlegada2).getSeconds();
                    c.segundos3 = typeof c.horaLlegada3.getSeconds === 'function' ? c.horaLlegada3.getSeconds() : new Date(c.horaLlegada3).getSeconds();
                    c.segundos4 = typeof c.horaLlegada4.getSeconds === 'function' ? c.horaLlegada4.getSeconds() : new Date(c.horaLlegada4).getSeconds();
                    c.segundos5 = typeof c.horaLlegada5.getSeconds === 'function' ? c.horaLlegada5.getSeconds() : new Date(c.horaLlegada5).getSeconds();
                    c.segundos6 = typeof c.horaLlegada6.getSeconds === 'function' ? c.horaLlegada6.getSeconds() : new Date(c.horaLlegada6).getSeconds();
                    c.segundos7 = typeof c.horaLlegada7.getSeconds === 'function' ? c.horaLlegada7.getSeconds() : new Date(c.horaLlegada7).getSeconds();
                    c.segundos8 = typeof c.horaLlegada8.getSeconds === 'function' ? c.horaLlegada8.getSeconds() : new Date(c.horaLlegada8).getSeconds();
                    c.segundos9 = typeof c.horaLlegada9.getSeconds === 'function' ? c.horaLlegada9.getSeconds() : new Date(c.horaLlegada9).getSeconds();
                    c.segundos10 = typeof c.horaLlegada10.getSeconds === 'function' ? c.horaLlegada10.getSeconds() : new Date(c.horaLlegada10).getSeconds();
                });
            }
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEventoIdChanged(property)
        {
            const result = validateSelectProperty($scope.dataForm, vm.criteriosBusqueda, property );
            
            vm.criteriosBusqueda.categoriaId = 0;
            vm.criteriosBusqueda.dia = 0;

            vm.categorias = [];
            vm.dias = [];

            if(result)
            {
                getComboData(vm.categorias, 'api/EventosCategorias', [vm.criteriosBusqueda.eventoId], 'Error al cargar las Categorias');
                getDias();
            }
        };

        function getDias()
        {
            const evento = vm.eventos.find((e)=>{return e.id == vm.criteriosBusqueda.eventoId;});

            if(evento)
            {
                for (let i = 1; i <= evento.dias; i++) {
                    
                    vm.dias.push({id: i, descripcion: `Dia ${i}`})
                }
            }
        };

    }
})();